// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3npMP","title":"InfoRow_title__1tary"};